/**
 * PAGE_HOTSPOT 题目布局 JSON 解析
 */

export function parseQuizLayoutConfig(raw) {
  if (!raw) return null
  let obj = raw
  if (typeof raw === 'string') {
    try {
      obj = JSON.parse(raw)
    } catch (e) {
      return null
    }
  }
  if (!obj || typeof obj !== 'object') return null
  return {
    stem: obj.stem && typeof obj.stem === 'object' ? obj.stem : null,
    options: Array.isArray(obj.options) ? obj.options : [],
    nextButton: obj.nextButton && typeof obj.nextButton === 'object' ? obj.nextButton : null
  }
}

/**
 * 嵌在活动页 background-wrapper 内的问答热点坐标（与模板里 hotspot-circle 的 rpxPx 用法一致）
 * @param {function(number): number|string} rpxPx 如 activity-multi 的 rpxPx，返回 px 数值或带 px 字符串均可
 */
export function quizLayoutHotspotAct004Style(box, rpxPx) {
  if (!box || typeof box !== 'object') return {}
  const px = (n) => {
    const v = typeof rpxPx === 'function' ? rpxPx(n) : n
    return typeof v === 'number' ? v + 'px' : v
  }
  const left = Number(box.left) || 0
  const top = Number(box.top) || 0
  const w = Number(box.sizeWidth) || 30
  const h = Number(box.sizeHeight) || 8
  return {
    left: px((left / 100) * 750),
    top: px((top / 100) * 1334),
    width: px((w / 100) * 750),
    height: px((h / 100) * 1334),
    borderRadius: '0'
  }
}

/** 与活动热点一致：left/top/sizeWidth/sizeHeight 为 0–100 相对画布百分比 */
export function quizHotspotBoxStyle(box, rpxPx) {
  if (!box || typeof box !== 'object' || typeof rpxPx !== 'function') return {}
  const left = Number(box.left) || 0
  const top = Number(box.top) || 0
  const w = Number(box.sizeWidth) || 80
  const h = Number(box.sizeHeight) || 8
  const style = {
    position: 'absolute',
    left: rpxPx((left / 100) * 750),
    top: rpxPx((top / 100) * 1334),
    width: rpxPx((w / 100) * 750),
    height: rpxPx((h / 100) * 1334),
    transform: 'translate(-50%, -50%)',
    boxSizing: 'border-box',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: (box.textAlign === 'center' ? 'center' : box.textAlign === 'right' ? 'flex-end' : 'flex-start'),
    fontSize: rpxPx(Number(box.fontSize) || 28),
    color: box.color || '#333333',
    fontWeight: box.fontWeight === 'bold' ? '700' : 'normal',
    paddingLeft: box.paddingLeft != null ? rpxPx(Number(box.paddingLeft) || 0) : undefined,
    lineHeight: 1.4
  }
  if (box.bgImage) {
    style.backgroundImage = `url(${box.bgImage})`
    style.backgroundSize = '100% 100%'
    style.backgroundRepeat = 'no-repeat'
  } else if (box.bgColor) {
    style.backgroundColor = box.bgColor
  }
  if (box.borderRadius != null) {
    style.borderRadius = rpxPx(Number(box.borderRadius) || 0)
  }
  if (box.borderColor) {
    style.border = `1px solid ${box.borderColor}`
  }
  return style
}

export function quizOptionSelectedStyle(box, selected, rpxPx) {
  const base = quizHotspotBoxStyle(box, rpxPx)
  if (!selected) return base
  const out = { ...base }
  if (box.selectedBgImage) {
    out.backgroundImage = `url(${box.selectedBgImage})`
    out.backgroundSize = '100% 100%'
    out.backgroundColor = ''
  } else if (box.selectedBgColor) {
    out.backgroundColor = box.selectedBgColor
    out.backgroundImage = ''
  }
  if (box.selectedBorderColor) {
    out.border = `2px solid ${box.selectedBorderColor}`
  }
  return out
}
